class HeaderDropdown extends HTMLElement {
    categories
    submenu
    constructor() {
        super();
        this.categories = this.querySelectorAll('.header__submenu_category[data-category]')
        this.submenu = this.querySelector('.header__submenu.list-menu')
        this.handleCategories()
    }
    handleCategories() {
        this.submenu.addEventListener('mouseenter', function () {
            this.classList.add('active')
        }.bind(this)
        )
        this.submenu.addEventListener('mouseleave', function () {
            this.classList.remove('active')
        }.bind(this)
        )
        this.categories.forEach(function (element) {
            const category = element.dataset.category
            element.addEventListener('mouseenter', function () {
                this.classList.add('active')
            }.bind(this)
            )
            element.addEventListener('mouseleave', function () {
                this.classList.remove('active')
            }.bind(this)
            )
            element.addEventListener('mouseover', function () {
                this.querySelector('.header__submenu_category.underline').classList.remove('underline')
                this.querySelector('.header-dropdown_wrappers:not(.hidden)').classList.add('hidden')
                this.querySelector('.header__submenu_products:not(.hidden)').classList.add('hidden')

                element.classList.add('underline')
                this.querySelector(`.header-dropdown_wrappers[data-category="${category}"]`).classList.remove('hidden')
                this.querySelector(`.header__submenu_products[data-category="${category}"]`).classList.remove('hidden')
                this.dataset.category = category;
            }.bind(this))
        }.bind(this))
    }
}
customElements.define('header-dropdown', HeaderDropdown);

